<template>
  <div :class="cn('size-14 border flex items-center text-foreground justify-center rounded-md', props.class)">
    <slot />
  </div>
</template>
<script setup lang="ts">
import { cn } from '@/lib/utils'
const props = defineProps({
  class: { type: null, required: false }
})
</script>
